export default __webpack_public_path__ + "static/media/106.3bf61dbf.jpg";